// src/components/admin/AdminCreateurs.jsx
// Chaque créateur : nb d'événements, billetterie Thrundrz vs externe, ventes, commission.

import React from "react";
import { useNavigate } from "react-router-dom";
import { getCreateurs } from "../../services/AdminGestionService";
import { useListeAdmin, TableAdmin, Pagination, Recherche, Filtre, EnTete, Badge, Action, BoutonActualiser, euros, dateFr } from "./AdminUI";

const AdminCreateurs = () => {
    const navigate = useNavigate();
    const L = useListeAdmin(getCreateurs, { q: "", billetterie: "", stripe: "", tri: "ventes" });

    const colonnes = [
        { cle: "name", titre: "Créateur", rendu: (c) => (
            <div>
                <div className="font-semibold text-gray-900">{c.name || "—"}</div>
                <div className="text-[11px] text-gray-500">{c.email}</div>
            </div>
        )},
        { cle: "nb_evenements", titre: "Événements", classe: "text-center", rendu: (c) => <b>{c.nb_evenements}</b> },
        { cle: "nb_a_venir", titre: "À venir", classe: "text-center" },
        { cle: "nb_thrundrz", titre: "Billetterie Thrundrz", classe: "text-center", rendu: (c) =>
            c.nb_thrundrz > 0 ? <Badge couleur="violet">{c.nb_thrundrz}</Badge> : <span className="text-gray-300">0</span> },
        { cle: "nb_externe", titre: "Externe", classe: "text-center", rendu: (c) =>
            c.nb_externe > 0 ? <Badge couleur="gris">{c.nb_externe}</Badge> : <span className="text-gray-300">0</span> },
        { cle: "billets_vendus", titre: "Billets vendus", classe: "text-center" },
        { cle: "ventes", titre: "Ventes (part orga)", classe: "text-right", rendu: (c) => euros(c.ventes) },
        { cle: "commission", titre: "Commission Thrundrz", classe: "text-right", rendu: (c) => <span className="text-green-700 font-semibold">{euros(c.commission)}</span> },
        { cle: "stripe", titre: "Stripe", rendu: (c) =>
            c.stripe_charges_enabled ? <Badge couleur="vert">Actif</Badge>
                : c.stripe_account_id ? <Badge couleur="orange">Incomplet</Badge>
                : <Badge couleur="gris">Aucun</Badge> },
        { cle: "created_at", titre: "Depuis", rendu: (c) => <span className="text-xs text-gray-500">{dateFr(c.created_at)}</span> },
        { cle: "actions", titre: "", rendu: (c) => (
            <Action onClick={() => navigate(`/admin/evenements?createur_id=${c.id}&nom=${encodeURIComponent(c.email)}`)}>
                Ses événements
            </Action>
        )},
    ];

    return (
        <div className="max-w-7xl mx-auto">
            <EnTete titre="Créateurs" sousTitre={`${L.page?.total ?? "…"} créateur(s)`}
                actions={<>
                    <Recherche valeur={L.filtres.q} onChange={(v) => L.setFiltre("q", v)} placeholder="Nom ou e-mail…" />
                    <Filtre valeur={L.filtres.billetterie} onChange={(v) => L.setFiltre("billetterie", v)}
                        options={[["", "Toutes billetteries"], ["thrundrz", "Utilise Thrundrz"]]} />
                    <Filtre valeur={L.filtres.stripe} onChange={(v) => L.setFiltre("stripe", v)}
                        options={[["", "Stripe : tous"], ["1", "Stripe actif"]]} />
                    <Filtre valeur={L.filtres.tri} onChange={(v) => L.setFiltre("tri", v)}
                        options={[["ventes", "Tri : ventes"], ["billets_vendus", "Tri : billets"], ["nb_evenements", "Tri : événements"]]} />
                    <BoutonActualiser onClick={L.recharger} />
                </>}
            />
            <TableAdmin colonnes={colonnes} lignes={L.page?.data} loading={L.loading} erreur={L.erreur} />
            <Pagination page={L.page} onPage={L.allerA} onParPage={L.setParPage} />
        </div>
    );
};

export default AdminCreateurs;